<template>
    <div>
        <div class="grid-container">
            <div class="grid-x grid-padding-x pad-top">
                <div class="cell small-12 medium-3 filter-box show-for-medium">
                    <label class="large-label text-blue border-under">Gender</label><br />
                    <span v-on:click="changeSex" data-value="men">Men</span><br />
                    <span v-on:click="changeSex" data-value="women">Women</span><br />
                    <span v-on:click="changeSex" data-value="unisex">Unisex</span><br />
                    <span v-on:click="changeSex" data-value="kids">Kids &amp; Babies</span><br />
                    <br />
                    <label class="large-label text-blue border-under">Products</label><br />
                    <span v-on:click="changeType" data-value="tshirts">T-Shirts</span><br />
                    <span v-on:click="changeType" data-value="long-sleeve-tshirts">Long Sleeved T-Shirts</span><br />
                    <span v-on:click="changeType" data-value="poloshirts">Polo Shirts</span><br />
                    <span v-on:click="changeType" data-value="long-sleeve-polo-shirts">Long Sleeved Polo Shirts</span><br />
                    <span v-on:click="changeType" data-value="sweatshirts">Sweat Shirts</span><br />
                    <span v-on:click="changeType" data-value="hoodies">Hoodies</span><br />
                    <span v-on:click="changeType" data-value="zippedhoodies">Zipped Hoodies</span><br />
                    <span v-on:click="changeType" data-value="shirts">Short Sleeved Shirts</span><br />
                    <span v-on:click="changeType" data-value="long-sleeve-shirts">Long Sleeved Shirts</span><br />
                    <span v-on:click="changeType" data-value="jackets">Jackets</span><br />
                    <span v-on:click="changeType" data-value="bodywarmers">Bodywarmers &amp; Gilets</span><br />
                    <span v-on:click="changeType" data-value="softshelljackets">Soft Shell Jackets</span><br />
                    <span v-on:click="changeType" data-value="fleeces">Fleeces</span><br />
                    <span v-on:click="changeType" data-value="hi-vis-jackets">Hi-Vis Jackets</span><br />
                    <span v-on:click="changeType" data-value="hi-vis-tshirts">Hi-Vis T-Shirts / Polos</span><br />
                    <span v-on:click="changeType" data-value="hi-vis-vests">Hi-Vis Vests</span><br />
                    <span v-on:click="changeType" data-value="hi-vis-trousers">Hi-Vis Trousers</span><br />
                    <span v-on:click="changeType" data-value="beanies">Beanies</span><br />
                    <span v-on:click="changeType" data-value="caps">Caps</span><br />
                    <span v-on:click="changeType" data-value="tote-bags">Tote Bags</span><br />
                    <span v-on:click="changeType" data-value="gymbags">Gym Bags</span><br />
                    <span v-on:click="changeType" data-value="backpacks">Backpacks</span><br />
                    <span v-on:click="changeType" data-value="messengerbags">Messenger Bags</span><br />
                    <span v-on:click="changeType" data-value="travelbags">Travel Bags</span><br />
                    <span v-on:click="changeType" data-value="joggingbottoms">Tracksuit Bottoms</span><br />
                    <span v-on:click="changeType" data-value="trousers">Trousers</span><br />
                    <span v-on:click="changeType" data-value="shorts">Shorts</span><br />
                    <br />
                    <label class="large-label text-blue border-under">Sizes</label><br />
                    <span v-on:click="filterSize" class="size-box" data-value="xs">XS</span>
                    <span v-on:click="filterSize" class="size-box" data-value="s">S</span>
                    <span v-on:click="filterSize" class="size-box" data-value="m">M</span>
                    <span v-on:click="filterSize" class="size-box" data-value="l">L</span>
                    <span v-on:click="filterSize" class="size-box" data-value="xl">XL</span>
                    <span v-on:click="filterSize" class="size-box" data-value="xxl">XXL</span>
                    <span v-on:click="filterSize" class="size-box" data-value=3xl>3XL</span>
                    <span v-on:click="filterSize" class="size-box" data-value=4xl>4XL</span>
                    <span v-on:click="filterSize" class="size-box" data-value="xxs">XXS</span>
                    <span v-on:click="filterSize" class="size-box" data-value="0">All</span>
                    <br /><br />
                    <label class="large-label text-blue border-under">Price</label><br />
                    <div class="pad-top--large">
                        <vue-slider
                            v-on:change="filterPrice"
                            v-bind:enable-cross="false"
                            v-bind:tooltip="'always'"
                            v-bind:max="75"
                            v-model="filters.priceRange"></vue-slider>
                    </div>
                    <br /><br />
                    <label class="large-label text-blue border-under">Colours</label><br />
                    <span
                        v-on:click="filterColour"
                        data-value="black"
                        class="colour-disk"
                        style="background-color:#000"
                        title="Black"></span>
                    <span
                        v-on:click="filterColour"
                        data-value="white"
                        class="colour-disk"
                        style="background-color:#FFF"
                        title="White"></span>
                    <span
                        v-on:click="filterColour"
                        data-value="red"
                        class="colour-disk"
                        style="background-color:red"
                        title="Red"></span>
                    <span
                        v-on:click="filterColour"
                        data-value="blue"
                        class="colour-disk"
                        style="background-color:blue"
                        title="Blue"></span>
                    <span
                        v-on:click="filterColour"
                        data-value="green"
                        class="colour-disk"
                        style="background-color:green"
                        title="Green"></span>
                    <span
                        v-on:click="filterColour"
                        data-value="grey"
                        class="colour-disk"
                        style="background-color:grey"
                        title="Grey"></span>
                    <span
                        v-on:click="filterColour"
                        data-value="yellow"
                        class="colour-disk"
                        style="background-color:yellow"
                        title="Yellow"></span>
                    <span
                        v-on:click="filterColour"
                        data-value="orange"
                        class="colour-disk"
                        style="background-color:orange"
                        title="Orange"></span>
                    <span
                        v-on:click="filterColour"
                        data-value="gold"
                        class="colour-disk"
                        style="background-color:gold"
                        title="Gold"></span>
                    <span
                        v-on:click="filterColour"
                        data-value="purple"
                        class="colour-disk"
                        style="background-color:purple"
                        title="Burgundy"></span>
                    <br /><br />
                    <button
                        class="button tall light-blue"
                        v-on:click="clearFilters">
                        Clear Filters
                    </button>
                </div>
                <div class="cell small-12 medium-9">
                    <div class="search-bar">
                        <div class="grid-x grid-padding-x">
                            <div class="cell small-12 medium-2">
                                <select
                                    v-model="selectGenderFilter"
                                    v-on:change="selectFilter('gender')"
                                    class="product-filter">
                                    <option value='all'>Gender</option>
                                    <option value='men'>Mens</option>
                                    <option value='women'>Womens</option>
                                    <option value='unisex'>Unisex</option>
                                    <option value='kids'>Kids &amp; Babies</option>
                                </select>
                            </div>
                            <div class="cell small-12 medium-2">
                                <select
                                    v-model="selectTypeFilter"
                                    v-on:change="selectFilter('type')"
                                    class="product-filter">
                                    <option value="all">Products</option>
                                    <option value="tshirts">T-Shirts</option>
                                    <option value="long-sleeve-tshirts">Long Sleeved T-Shirts</option>
                                    <option value="poloshirts">Polo Shirts</option>
                                    <option value="long-sleeve-polo-shirts">Long Sleeved Polo Shirts</option>
                                    <option value="sweatshirts">Sweat Shirts</option>
                                    <option value="hoodies">Hoodies</option>
                                    <option value="zippedhoodies">Zipped Hoodies</option>
                                    <option value="shirts">Short Sleeved Shirts</option>
                                    <option value="long-sleeve-shirts">Long Sleeved Shirts</option>
                                    <option value="jackets">Jackets</option>
                                    <option value="bodywarmers">Bodywarmers &amp; Gilets</option>
                                    <option value="softshelljackets">Soft Shell Jackets</option>
                                    <option value="fleeces">Fleeces</option>
                                    <option value="hi-vis-jackets">Hi-Vis Jackets</option>
                                    <option value="hi-vis-tshirts">Hi-Vis T-Shirts / Polos</option>
                                    <option value="hi-vis-vests">Hi-Vis Vests</option>
                                    <option value="hi-vis-trousers">Hi-Vis Trousers</option>
                                    <option value="beanies">Beanies</option>
                                    <option value="caps">Caps</option>
                                    <option value="tote-bags">Tote Bags</option>
                                    <option value="gymbags">Gym Bags</option>
                                    <option value="backpacks">Backpacks</option>
                                    <option value="messengerbags">Messenger Bags</option>
                                    <option value="travelbags">Travel Bags</option>
                                    <option value="joggingbottoms">Tracksuit Bottoms</option>
                                    <option value="trousers">Trousers</option>
                                    <option value="shorts">Shorts</option>
                                </select>
                            </div>
                            <div class="cell small-12 medium-2">
                                <select
                                    v-model="selectBrandFilter"
                                    v-on:change="selectFilter('brand')"
                                    class="product-filter">
                                    <option value="all">Brand</option>
                                    <option value="American Apparel">American Apparel</option>
                                    <option value="Anvil">Anvil</option>
                                    <option value="AWDis">AWDis</option>
                                    <option value="BagBase">BagBase</option>
                                    <option value="Beechfield">Beechfield</option>
                                    <option value="Bella-Canvas">Bella-Canvas</option>
                                    <option value="Brook Taverner">Brook Taverner</option>
                                    <option value="Canterbury">Canterbury</option>
                                    <option value="Craghoppers">Craghoppers</option>
                                    <option value="Dickies">Dickies</option>
                                    <option value="Ecologie">Ecologie</option>
                                    <option value="Errea">Errea</option>
                                    <option value="Finden and Hales">Finden and Hales</option>
                                    <option value="Flexfit">Flexfit</option>
                                    <option value="Front Row">Front Row</option>
                                    <option value="Fruit of the Loom">Fruit of the Loom</option>
                                    <option value="Gamegear">Gamegear</option>
                                    <option value="Gildan">Gildan</option>
                                    <option value="Glenmuir">Glenmuir</option>
                                    <option value="Henbury">Henbury</option>
                                    <option value="Jerzees">Jerzees</option>
                                    <option value="Kariban">Kariban</option>
                                    <option value="Kustom Kit">Kustom Kit</option>
                                    <option value="Larkwood">Larkwood</option>
                                    <option value="Original FNB">Original FNB</option>
                                    <option value="Portwest">Portwest</option>
                                    <option value="Premier">Premier</option>
                                    <option value="PRO RTX">PRO RTX</option>
                                    <option value="Proact">Proact</option>
                                    <option value="Quadra">Quadra</option>
                                    <option value="Regatta">Regatta</option>
                                    <option value="Result">Result</option>
                                    <option value="Russell">Russell</option>
                                    <option value="Skinny Fit">Skinny Fit</option>
                                    <option value="So Denim">So Denim</option>
                                    <option value="SOL">SOL</option>
                                    <option value="Spiro">Spiro</option>
                                    <option value="Splashmacs">Splashmacs</option>
                                    <option value="Superstar">Superstar</option>
                                    <option value="Tactical Threads">Tactical Threads</option>
                                    <option value="Tee Jays">Tee Jays</option>
                                    <option value="Tombo">Tombo</option>
                                    <option value="Warrior">Warrior</option>
                                    <option value="Westford Mills">Westford Mills</option>
                                    <option value="Yoko">Yoko</option>
                                </select>
                            </div>
                            <div class="cell small-12 medium-2">
                                <select
                                    v-model="selectOrderPrice"
                                    v-on:change="selectFilter('orderPrice')"
                                    class="product-filter">
                                    <option value="all">Sort by Price</option>
                                    <option value="orderPriceHiLo">Price Hi to Lo</option>
                                    <option value="orderPriceLoHi">Price Lo to Hi</option>
                                </select>
                            </div>
                            <div class="cell small-12 medium-4">
                                <form v-on:submit="submitSearch">
                                    <input
                                        class="product-search"
                                        placeholder="Search and hit enter"
                                        v-model="searchTerm"
                                        type="text" />
                                </form>
                            </div>
                        </div>
                    </div>
                    <div
                        v-if="message.length > 0"
                        class="clear grid-x grid-padding-x">
                        <div class="cell small-12">
                            <h2>{{ message }}</h2>
                        </div>
                    </div>
                    <div class="clear grid-x grid-margin-x">
                        <div
                            v-for="(garment, index) in garments"
                            v-bind:key="index"
                            class="cell small-6 medium-4 garment-card marg-bottom--small pad--xs relative">
                            <div>
                                <span
                                    v-if="isAuthenticated === true"
                                    v-on:click="addFavourite(garment.id)"
                                    class="favourite">
                                    <img src="../../../static/images/filter-garments/favourite.png" alt="" />
                                </span>
                                <router-link
                                    v-bind:to="`/${garment.category}/${garment.product_code}/${garment.slug}`">
                                    <div class="small-pad--small medium-pad--large">
                                        <img
                                            v-bind:src="`https://our-catalogue.com/RUNS/images/${garment.product_code}.jpg?width=300`"
                                            v-bind:alt="garment.img_alt_tag" />
                                    </div>
                                    <h5 class="text-blue" v-if="garment.featured_garment !== 'false'">
                                        {{ garment.featured_garment }}
                                    </h5>
                                    <p class="small">
                                        {{ garment.product_code }}<br />
                                        {{ garment.name }}<br />
                                        Price from:
                                        <span class="text-light-blue">
                                            £{{ (((garment.garment_colours[0].garment_colour_sizes[0].price*21)/100)+garment.garment_colours[0].garment_colour_sizes[0].price) | numeral('0,0.00') }}
                                        </span>
                                    </p>
                                    <p class="add-to-basket">
                                        <img
                                            width="55"
                                            src="../../../static/images/filter-garments/add-to-basket.png"
                                            alt="" />
                                    </p>
                                </router-link>
                            </div>
                        </div>
                    </div>
                    <div v-if="allLoaded === false" class="clear grid-x grid-padding-x">
                        <div class="cell small-12 text-center pad-top pad-bottom">
                            <button
                                class="button"
                                v-if="offset > 10"
                                v-on:click="loadMoreGarments">
                                Load More
                            </button>
                        </div>
                    </div>
                    <div v-if="category !== false" class="clear grid-x grid-padding-x">
                        <div class="cell small-12 pad-top pad-bottom">
                            <h1>{{ category.h1 }}</h1>
                            <div v-html="category.content"></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import VueSlider from 'vue-slider-component';
import 'vue-slider-component/theme/default.css';
import axios from '../../axios';

export default {
    name: 'FilterGarment',
    metaInfo() {
        return {
            title: this.metaTitle,
            titleTemplate: '%s-CustomisedClothing',
            meta: [
                { description: this.metaDescription },
            ],
            link: [
                { rel: 'canonical', href: `https://customisedclothing.com/garments/${this.type}` },
            ],

        };
    },
    computed: {
        metaTitle() {
            let title = 'Garments';
            if (this.category !== false && this.category.meta_title) {
                title = this.category.meta_title;
            }
            return title;
        },
        metaDescription() {
            let description = 'Garments';
            if (this.category !== false && this.category.meta_description) {
                description = this.category.meta_description;
            }
            return description;
        },
        type() {
            return this.$route.params.type;
        },
        niceType() {
            const type = this.$route.params.type;
            if (type === 'tshirts') return 'T-Shirts';
            if (type === 'long-sleeve-tshirts') return 'Long Sleeved T-Shirts';
            if (type === 'sweatshirts') return 'Sweat Shirts';
            if (type === 'poloshirts') return 'Polo Shirts';
            if (type === 'long-sleeve-polo-shirts') return 'Long Sleeved Polo Shirts';
            if (type === 'hoodies') return 'Hoodies';
            if (type === 'zippedhoodies') return 'Zipped Hoodies';
            if (type === 'shirts') return 'Shirts';
            if (type === 'long-sleeve-shirts') return 'Long Sleeved Shirts';
            if (type === 'ladiesshirts') return 'Ladies Shirts';
            if (type === 'lsladiesshirts') return 'Long Sleeved Ladies Shirts';
            if (type === 'jackets') return 'Jackets';
            if (type === 'bodywarmers') return 'Bodywarmers & Gilets';
            if (type === 'softshelljackets') return 'Soft Shell Jackets';
            if (type === 'fleeces') return 'Fleeces';
            if (type === 'beanies') return 'Beanies';
            if (type === 'caps') return 'Caps';
            if (type === 'tote-bags') return 'Tote Bags';
            if (type === 'gymbags') return 'Gymbags';
            if (type === 'backpacks') return 'Backpacks';
            if (type === 'messengerbags') return 'Messenger Bags';
            if (type === 'travelbags') return 'Travel Bags';
            if (type === 'joggingbottoms') return 'Jogging Bottoms';
            if (type === 'trousers') return 'Trousers';
            if (type === 'hi-vis-jackets') return 'Hi-Vis Jackes';
            if (type === 'hvtshirts') return 'Hi-Vis T-Shirts and Polos';
            if (type === 'hi-vis-vests') return 'Hi-Vis Vests';
            if (type === 'hi-vis-trousers') return 'Hi-Vis Trousers';
            if (type === 'shorts') return 'Shorts';
            return 'None';
        },
        isAuthenticated() {
            return this.$store.getters.isAuthenticated;
        },
        authData() {
            return this.$store.getters.authData;
        },
    },
    data() {
        return {
            garments: [],
            garment: {},
            filters: {
                brand: '',
                type: 'all',
                colour: 0,
                size: 0,
                price: 0,
                sex: '',
                priceRange: [0, 75],
            },
            offset: -10,
            loading: false,
            allLoaded: false,
            singleGarment: false,
            activeColour: false,
            basketItems: [],
            nextButtons: false,
            searchTerm: '',
            colours: [],
            message: '',
            selectGenderFilter: 'all',
            selectTypeFilter: 'all',
            selectBrandFilter: 'all',
            selectOrderPrice: 'all',
            featuredLoaded: false,
            category: false,
        };
    },
    components: {
        VueSlider,
    },
    methods: {
        submitSearch(event) {
            event.preventDefault();
            this.garments = [];
            this.loading = false;
            this.allLoaded = false;
            this.featuredLoaded = false;
            this.offset = -10;
            this.category = false;
            const postData = {};
            const garments = [];
            postData.term = this.searchTerm;
            axios.post('/Garments/search.json', postData)
            .then((response) => {
                if (response.data.garments.length === 0) {
                    this.allLoaded = true;
                    this.loading = false;
                    if (this.garments.length === 0) {
                        this.message = 'Sorry, nothing matched your search.';
                    }
                } else {
                    this.message = '';
                    for (let i = 0; i < response.data.garments.length; i += 1) {
                        garments.push(response.data.garments[i]);
                    }
                    this.garments = this.garments.concat(garments);
                    this.category = response.data.category;
                    const routePath = this.$route.path;
                    const oldParam = this.$route.params.type;
                    const newRoute = routePath.replace(oldParam, this.category.slug);
                    history.pushState(
                        {},
                        null,
                        newRoute,
                    );
                    this.loading = false;
                    window.removeEventListener('scroll', this.handleScroll);
                }
            });
        },
        selectFilter(filterType) {
            this.garments = [];
            this.loading = false;
            this.allLoaded = false;
            this.featuredLoaded = false;
            this.offset = -10;
            if (filterType === 'gender') {
                if (this.selectGenderFilter === 'all') {
                    this.filters.sex = '';
                } else {
                    this.filters.sex = this.selectGenderFilter;
                }
            }
            if (filterType === 'type') {
                this.filters.type = this.selectTypeFilter;
                this.$router.push(`/garments/${this.selectTypeFilter}`);
            }
            if (filterType === 'brand') {
                if (this.selectBrandFilter === 'all') {
                    this.filters.brand = '';
                } else {
                    this.filters.brand = this.selectBrandFilter;
                }
            }
            if (filterType === 'orderPrice') {
                this.filters.order = this.selectOrderPrice;
                this.handleScroll();
                return;
            }
            this.getFeatured();
            // this.handleScroll();
        },
        addFavourite(garment) {
            const postData = {};
            postData.garment = garment;
            postData.user = this.authData.userEmail;
            axios.post(`/Favourites/add.json?auth=${this.authData.token}&user=${this.authData.user}&cage=${this.authData.cage}`, postData);
        },
        clearFilters() {
            this.filters.type = 'all';
            this.filters.colour = 0;
            this.filters.size = 0;
            this.filters.price = 0;
            this.value = [0, 100];
            this.garments = [];
            this.loading = false;
            this.allLoaded = false;
            this.featuredLoaded = false;
            this.offset = -10;
            this.getFeatured();
            // this.handleScroll();
        },
        changeSex(event) {
            const element = event.currentTarget;
            const sex = element.getAttribute('data-value');
            this.filters.sex = sex;
            this.selectGenderFilter = sex;
            this.garments = [];
            this.loading = false;
            this.allLoaded = false;
            this.featuredLoaded = false;
            this.offset = -10;
            this.getFeatured();
            // this.handleScroll();
        },
        changeType(event) {
            const element = event.currentTarget;
            const type = element.getAttribute('data-value');
            this.filters.type = type;
            this.selectTypeFilter = type;
            this.$router.push(`/garments/${type}`);
            this.garments = [];
            this.loading = false;
            this.allLoaded = false;
            this.featuredLoaded = false;
            this.offset = -10;
            this.getFeatured();
            this.handleScroll();
        },
        filterPrice() {
            const price = this.value;
            this.filters.price = price;
            this.garments = [];
            this.loading = false;
            this.allLoaded = false;
            this.featuredLoaded = false;
            this.offset = -10;
            this.getFeatured();
            this.handleScroll();
        },
        filterColour(event) {
            const element = event.currentTarget;
            const colour = element.getAttribute('data-value');
            this.filters.colour = colour;
            this.garments = [];
            this.loading = false;
            this.allLoaded = false;
            this.featuredLoaded = false;
            this.offset = -10;
            this.getFeatured();
            this.handleScroll();
        },
        filterSize(event) {
            const element = event.currentTarget;
            const size = element.getAttribute('data-value');
            this.filters.size = size;
            this.garments = [];
            this.loading = false;
            this.allLoaded = false;
            this.featuredLoaded = false;
            this.offset = -10;
            this.getFeatured();
            this.handleScroll();
        },
        handleScroll() {
            if (this.loading === false && this.allLoaded === false && this.offset <= 10) {
                this.message = '';
                this.loading = true;
                this.offset = this.offset + 10;
                const payload = {};
                payload.offset = this.offset;
                payload.filters = this.filters;
                payload.featured = false;
                const garments = [];
                this.category = false;
                const type = this.type;
                axios.post(`/Garments/fetch.json?type=${type}`, payload)
                    .then((response) => {
                        if (response.data.garments.length === 0) {
                            this.allLoaded = true;
                            this.loading = false;
                            if (this.garments.length === 0) {
                                this.message = 'Sorry, nothing matched your search.';
                            }
                        } else {
                            for (let i = 0; i < response.data.garments.length; i += 1) {
                                garments.push(response.data.garments[i]);
                            }
                            this.garments = this.garments.concat(garments);
                            this.loading = false;
                        }
                        this.category = response.data.category;
                    });
            }
        },
        loadMoreGarments() {
            if (this.loading === false && this.allLoaded === false) {
                this.message = '';
                this.loading = true;
                this.offset = this.offset + 10;
                const payload = {};
                payload.offset = this.offset;
                payload.filters = this.filters;
                payload.featured = false;
                const garments = [];
                const type = this.type;
                this.category = false;
                axios.post(`/Garments/fetch.json?type=${type}`, payload)
                    .then((response) => {
                        if (response.data.garments.length === 0) {
                            this.allLoaded = true;
                            this.loading = false;
                            if (this.garments.length === 0) {
                                this.message = 'Sorry, nothing matched your search.';
                            }
                        } else {
                            for (let i = 0; i < response.data.garments.length; i += 1) {
                                garments.push(response.data.garments[i]);
                            }
                            this.garments = this.garments.concat(garments);
                            this.loading = false;
                        }
                        this.category = response.data.category;
                    });
            }
        },
        getFeatured() {
            if (this.featuredLoaded === false) {
                this.featuredLoaded = true;
                this.message = '';
                const payload = {};
                payload.offset = this.offset;
                payload.filters = this.filters;
                payload.featured = true;
                const garments = [];
                const type = this.type;
                this.category = false;
                axios.post(`/Garments/fetch.json?type=${type}`, payload)
                    .then((response) => {
                        if (response.data.garments.length > 0) {
                            for (let i = 0; i < response.data.garments.length; i += 1) {
                                garments.push(response.data.garments[i]);
                            }
                            this.garments = this.garments.concat(garments);
                            this.loading = false;
                        }
                        this.category = response.data.category;
                        this.handleScroll();
                    });
            }
        },
        checkBrand() {
            if (this.$route.query.brand) {
                this.filters.brand = this.$route.query.brand;
                this.selectBrandFilter = this.$route.query.brand;
            }
        },
        loadMore() {
            this.scroll = true;
            this.featuredLoaded = false;
            this.handleScroll();
        },
        checkGender() {
            if (this.$route.params.gender) {
                this.filters.sex = this.$route.params.gender;
                this.selectGenderFilter = this.$route.params.gender;
            }
        },
    },
    /*
    watch: {
        $route() {
            this.garments = [];
            this.loading = false;
            this.allLoaded = false;
            this.featuredLoaded = false;
            this.offset = -10;
            this.checkBrand();
            this.getFeatured();
            // this.handleScroll();
        },
    },
    */
    created() {
        window.addEventListener('scroll', this.handleScroll);
        this.filters.type = this.type;
    },
    mounted() {
        this.checkGender();
        this.checkBrand();
        this.getFeatured();
    },
    destroyed() {
        window.removeEventListener('scroll', this.handleScroll);
    },
};
</script>



// WEBPACK FOOTER //
// src/components/Garments/FilterGarments.vue